
/**
 * Preprends http protocol to a string if it's not present
 * @param {string} val The string the manipulate
 */
export const prependHttpString = val => !!val && !new RegExp('^(http|https)://', 'i').test(val) ? `https://${val}` : val;
